import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import ProgressLine from '../../atoms/timeline/ProgressLine';
import ProgressIndicator from './ProgressIndicator';
const StyledBackground = styled.div `
    position: absolute;
    top: 26px;
    bottom: 26px;
    left: 50%;
    width: 3px;
    margin-left: -1.5px;
    background-image: linear-gradient(rgba(166, 167, 167, 0.6) 60%, white 0%);
    background-position: top right;
    background-size: 1px 14px;
    background-repeat: repeat-y;
`;
const ProgressBackground = ({ value, height }) => (_jsxs(StyledBackground, { children: [_jsx(ProgressLine, { height: height }), _jsx(ProgressIndicator, { value: new Date(value).toLocaleDateString('nl-nl', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            }) })] }));
export default ProgressBackground;
